// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-initialcase[data-v-67d0fb17] {\n    text-transform: initial;\n}\n", ""]);
// Exports
module.exports = exports;
